export const formatQty = (val: string, un?: string) => {
  const formatUn = un?.toLowerCase() || '';
  const isKg = formatUn === 'kg';
  let num = parseFloat(
    val.replace('kg', '').replace('Kg', '').replace(',', '.'),
  );
  if (isNaN(num) || num === 0) return '';
  if (!isKg) return String(Math.floor(num));
  if (num < 1) {
    return `${Math.round(num * 1000)} g`;
  } else if (Number.isInteger(num)) {
    return `${num.toFixed(0)} ${formatUn}`;
  } else {
    return `${num.toFixed(1).replace('.', ',')} ${formatUn}`;
  }
};